import { combineReducers } from "@reduxjs/toolkit";
import Auth_Reducer from "./authReducer";
import Home_Reducer from "./homeReducer";
import Item_Reducer from "./itemReducer";
export const rootReducer = combineReducers({
  AUTH: Auth_Reducer,
  Home: Home_Reducer,
  Item: Item_Reducer,
});
